angular.module('PatientApp').factory('BrandingConfigService', function(Subdomain, $q, $resource, endpoints){
    var BrandingConfig = $resource(null, null, {
        getConfig: {
            method: 'GET',
            url: endpoints.providers.brand.url + '/' + Subdomain
        }
    });

    return {
        getConfig: function() {
            if (Subdomain) {
                return BrandingConfig.getConfig().$promise
                .then(function(resp){
                    if(resp && resp.hasData()){
                        return resp.getData();
                    }
                    return $q.reject(resp);
                });
            } else {
                return $q.reject('No subdomain set');
            }
        }
    };

});
